import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

const Seo = ({ description = '', title, image, showTitleSuffix = true }) => {
  const { site } = useSeoSite()
  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  const pageTitle = GetSeoPageTitle(showTitleSuffix, title, defaultTitle)

  return (
    <>
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription}></meta>
      <meta name="image" content={image}></meta>
      <meta name="og:title" content={title}></meta>
      <meta name="og:type" content="website"></meta>
      <meta name="twitter:card" content="summary_large_image"></meta>
      <meta name="twitter:creator" content={site.siteMetadata?.social?.twitter || null}></meta>
      <meta name="twitter:title" content={title}></meta>
      <meta name="twitter:description" content={metaDescription}></meta>
    </>
  )
}

export default Seo



export function GetSeoPageTitle(showTitleSuffix, title, defaultTitle) {
  const myTitleSuffix = showTitleSuffix ? ` | ${defaultTitle}` : ''
  let myPageTitle = defaultTitle

  if (title) {
    myPageTitle = `${title}${myTitleSuffix}`
  }

  return myPageTitle
}

export const useSeoSite = () => {
  return useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  )
}